import { render, staticRenderFns } from "./bill-detail.vue?vue&type=template&id=5d8ddace&scoped=true&"
import script from "./bill-detail.vue?vue&type=script&lang=js&"
export * from "./bill-detail.vue?vue&type=script&lang=js&"
import style0 from "./bill.scss?vue&type=style&index=0&id=5d8ddace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ddace",
  null
  
)

export default component.exports